/**
 * 考核api。
 * @author 王振宇
 * @since 2022-09-24
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_AGENCYMEMBEREXAMINATION_PAGE_LIST: function GET_AGENCYMEMBEREXAMINATION_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/AgencyMemberExamination/getPageList',
        method: 'post',
        data: data
      });
    }
  };
});